import { render, staticRenderFns } from "./OrganizFooter.vue?vue&type=template&id=1012dc1a&scoped=true&"
import script from "./OrganizFooter.vue?vue&type=script&lang=js&"
export * from "./OrganizFooter.vue?vue&type=script&lang=js&"
import style0 from "./OrganizFooter.vue?vue&type=style&index=0&id=1012dc1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1012dc1a",
  null
  
)

export default component.exports